import { useEffect } from "react";
import { createPortal } from "react-dom";
import { NichePickerContent } from "./NichePicker";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function NichePickerModal({ open = false, onDismiss = null, onSelect = null }) {
    useEffect(() => {
        if (!open) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const handleKeyDown = (event) => {
            if (event.key === "Escape") onDismiss?.();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onDismiss]);

    if (!open) return null;

    return createPortal(
        <div
            className="fixed inset-0 z-[200] flex items-end justify-center bg-slate-900/50 p-0 sm:items-center sm:p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="niche-picker-title"
            onClick={onDismiss}
        >
            <div
                className="relative w-full max-w-lg overflow-hidden rounded-t-2xl bg-white shadow-xl sm:rounded-2xl"
                onClick={(event) => event.stopPropagation()}
            >
                <button
                    type="button"
                    onClick={onDismiss}
                    className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100 hover:text-slate-900"
                    aria-label="Close"
                >
                    <i className="bi bi-x-lg" aria-hidden />
                </button>
                <div className="px-4 py-5 pr-12 sm:px-6 sm:py-6">
                    <NichePickerContent onSelect={onSelect} />
                </div>
            </div>
        </div>,
        document.body
    );
}
